import React from 'react';

import Page from 'components/page/Page';
import { t } from 'utils/language';
import LoginForm from '../components/LoginForm';
import AccessContainer from '../components/access-container/AccessContainer';
import AccessContainerHeader from '../components/access-container/access-container-header/AccessContainerHeader';
import AccessContainerFooter from '../components/access-container/access-container-footer/AccessContainerFooter';

import type { LocationWindow } from 'types';

type Props = {
  location: LocationWindow
};

const LoginPage = ({ location }: Props) => (
  <Page
    documentTitle={t('access_login_page')}
  >
    <AccessContainer type="login">
      <AccessContainerHeader title={t('login_header')} />
      <LoginForm location={location} />
      <AccessContainerFooter
        message={t('login_footer_no_account')}
        linkText={t('login_footer_sign_up')}
        linkTo="/signup"
      />
    </AccessContainer>
  </Page>
);

export default LoginPage;
